import React, { useEffect, useRef, useState } from 'react';
import useDeferredRowChange from './useDeferredRowChange';

/**
 * Currency-prefixed text cell.
 *
 * cellRendererParams (merged with column.cellProps):
 *   onRowChange(rowId, field, value)
 *   getRowId(row) -> string
 *   currencySymbol  (default '£')
 *   placeholder     falls back to the column's headerName, then 'Text Box'
 *   disabled
 *   readOnly
 */
function CurrencyInputCell(params) {
  const { value, data, colDef, onRowChange, getRowId, currencySymbol = '£', placeholder, disabled, readOnly, error } = params;
  const rowId = getRowId ? getRowId(data) : data?.id;
  const field = colDef?.field;

  const focusedRef = useRef(false);
  const [local, setLocal] = useState(value ?? '');
  const [commitChange, flushChange] = useDeferredRowChange(onRowChange);

  useEffect(() => {
    if (!focusedRef.current) setLocal(value ?? '');
  }, [value]);

  const handleChange = (e) => {
    const cleaned = e.target.value.replace(/[^0-9.\-]/g, '');
    setLocal(cleaned);
    commitChange(rowId, field, cleaned);
  };

  return (
    <div className={`cag-cell-wrap${error ? ' cag-cell-wrap--error' : ''}`}>
      <div className="cag-cell">
        <div className="cag-affix-field">
          <span className="cag-affix cag-affix-prefix force-ltr">{currencySymbol}</span>
          <input
            className="cag-affix-input"
            type="text"
            inputMode="decimal"
            value={local}
            placeholder={placeholder ?? colDef?.headerName ?? 'Text Box'}
            disabled={disabled}
            readOnly={readOnly}
            onFocus={() => {
              focusedRef.current = true;
            }}
            onBlur={() => {
              focusedRef.current = false;
              flushChange();
              setLocal(value ?? '');
            }}
            onChange={handleChange}
          />
        </div>
      </div>
      {error ? <span className="cag-cell-error">{error}</span> : null}
    </div>
  );
}

export default CurrencyInputCell;
